// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"362":"ea885c22","836":"ee089d57","904":"eb79f75b"}[chunkId] + ".chunk.js";
};